import { MenuItem } from "./menu-item";
export class MenuCategoryItem {
    constructor(id, menuCategoryId, menuItem, sortOrder) {
        this.id = id;
        this.menuCategoryId = menuCategoryId;
        this.menuItem = menuItem;
        this.sortOrder = sortOrder;
    }
    static fromDynamic(data) {
        return new MenuCategoryItem(data["id"], data["menu_category_id"], MenuItem.fromDynamic(data["menu_item"]), data["sort_order"]);
    }
}
//# sourceMappingURL=menu-category-item.js.map